import script from "./new-edit-email-templates-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-edit-email-templates-modal.vue?vue&type=script&setup=true&lang=ts"

import "./new-edit-email-templates-modal.vue?vue&type=style&index=0&id=3a6bb9c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a6bb9c0"]])

export default __exports__